module.exports = __webpack_public_path__ + "static/media/minus-hexagon.7054ffa4.svg";